package org.gymly.util

import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi

/** MIME from magic bytes (fallback jpeg). */
fun guessImageMime(bytes: ByteArray): String {
    if (bytes.size >= 3 && bytes[0] == 0xFF.toByte() && bytes[1] == 0xD8.toByte() && bytes[2] == 0xFF.toByte()) {
        return "image/jpeg"
    }
    if (bytes.size >= 8 &&
        bytes[0] == 0x89.toByte() && bytes[1] == 0x50.toByte() && bytes[2] == 0x4E.toByte() && bytes[3] == 0x47.toByte()
    ) {
        return "image/png"
    }
    if (bytes.size >= 6 &&
        bytes[0] == 0x47.toByte() && bytes[1] == 0x49.toByte() && bytes[2] == 0x46.toByte()
    ) {
        return "image/gif"
    }
    if (bytes.size >= 12 &&
        bytes[0] == 0x52.toByte() && bytes[1] == 0x49.toByte() && bytes[2] == 0x46.toByte() && bytes[3] == 0x46.toByte()
    ) {
        return "image/webp"
    }
    return "image/jpeg"
}

/**
 * Data-URI for Coil/browser. Prefer this over raw [ByteArray] on JS/Wasm,
 * where Coil often fails to decode byte models without a platform ImageDecoder.
 */
@OptIn(ExperimentalEncodingApi::class)
fun imagePreviewModel(bytes: ByteArray?, mimeHint: String? = null): String? {
    if (bytes == null || bytes.isEmpty()) return null
    val mime = mimeHint?.takeIf { it.startsWith("image/") } ?: guessImageMime(bytes)
    return "data:$mime;base64,${Base64.encode(bytes)}"
}
